import React from 'react';
import { useTranslation } from 'react-i18next';

import { UserProfile } from '../../generated/graphql';
import ColorDot from '../ColorDot';

export type CellUserType = Pick<UserProfile, 'gender' | 'firstName' | 'lastName'>;

type Props = {
  profile: CellUserType | undefined
  dot?: boolean
};

const TableCellUser = ({ profile, dot }: Props) => {
  const { t } = useTranslation();

  if (!profile) {
    return <span>-</span>;
  }

  const { gender, lastName, firstName } = profile;

  return (
    <div className="d-flex align-items-center justify-content-center gap-1">
      <span>{`${t(`gender.${gender}`)} ${lastName} ${firstName}`}</span>
      {dot ? (
        <ColorDot />
      ) : null}
    </div>
  );
};

TableCellUser.defaultProps = ({
  dot: undefined,
});

export default TableCellUser;
